import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/auth';
import { FileUploadChild, FormButton, InputBox, handleFileUploader } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';
//loder
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER, initializeFilterData } from '../../Utils';
//services
import { FileUploader } from "react-drag-drop-files";
import { post } from '../../apiservices/service';
import { Token } from '../Common/Common';

function CompanyPolicyMaster() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        PolicyID:"0",
        PolicyName:"",
        DocFileBase64: "",
        DocFileExt: "",
        DocFileName: ""
    })
    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false)
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isUpdate, setIsUpdate] = useState(false)
    const [errors, setErrors] = useState({});
    const fileType = "pdf";

    const getFormData = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        setLoading(true)
        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s",
        }
        post(`${API_SERVER}api/Master/ShowCompanyPolicyMaster`, { ...TokenData, ...temp, ...sortConfig, ...filterData, }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setResult({ ...res })
                }
            }
        });
    }

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }
    const handleChange1 = (event, value) => {
        getFormData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    //validation handler
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "PolicyName", msg: 'Please enter ploicy name.' },
            { field: "DocFileBase64", msg: 'Please Select Document File .' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        return isValid;
    }
    //Submit Handler
    const handleSubmit = () => {
        const myString = Validate();
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Master/SaveUpdateCompanyPolicy`, { ...TokenData, ...recipe}, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setLoading(false)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        handleClear()
                    }
                }
            });
        }
        else {
        }
    }

    //Handle Edit
    const handleEdit = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/Master/EditCompanyPolicyMaster`, { ...TokenData, PolicyID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    let data = res.data
                    setRecipe({
                        ...data,
                        PolicyID: data.policyID,
                        PolicyName: data.policyName,
                        DocFileBase64: data.docFileBase64,
                        DocFileExt: data.docFileExt,
                        DocFileName: data.docFileName,
                    })
                }
            }
        });
    }

    //Handle Delete
    const handleDelete = (Id) => {
        setLoading(true)
        post(`${API_SERVER}api/Master/DeleteCompanyPolicy`, { ...TokenData, PolicyID: Id }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    toast.success(res.message)
                    setLoading(false)
                    getFormData()
                }
            }
        });
    }

    // Handle Show Documents
    const HandleShowDoc = (ID, key) => {
        setLoading(true)
        post(`${API_SERVER}api/Master/ShowPolicyDocument`, { ...TokenData, PolicyID: ID}, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    toast.error(res.message)
                } else if (res.status === "EXPIRED") {
                    toast.error(res.message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    let base64 = res && res.document
                    const byteCharacters = atob(base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: res.documentExtention === '' ? toast.error('No Document Uploaded') : res.documentExtention === 'pdf' ? 'application/pdf' : 'image/jpeg' });
                    const blobURL = URL.createObjectURL(blob);
                    setLoading(false)
                    const pdfWindow = window.open();
                    if (pdfWindow) {
                        pdfWindow.location.href = blobURL;
                    } else {
                        alert("Popup blocked! Please allow popups for this website.");
                    }
                }
            }
        });
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            PolicyID: "0",
            PolicyName: "",
            DocFileBase64: "",
            DocFileExt: "",
            DocFileName: "",
        }))
        setErrors({})
        setFilterData(filterData => ({ ...filterData, SearchText: '' }))
        setIsUpdate(!isUpdate)
        getFormData()
    }

    useEffect(() => {
            inputrefs.current['txtPolicyName'].focus();
            document.title = 'Viva HRMS : Company Policy Master'
            getFormData();
    }, [sortConfig, isUpdate])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-body'>
                    <div className='row p-0 ps-3 pt-2'>
                        <div className='row'>
                            <div className='row'>
                                <fieldset className="myfieldset">
                                    <legend className="mylegend"> <h6 className="m-0">Company Policy Master</h6></legend>
                                    <div className='row'>
                                        <InputBox
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { inputrefs.current['fileDocument'].focus() };
                                            }}
                                            label='Policy Name'
                                            id='txtPolicyName'
                                            maxLength='50'
                                            placeholder='Policy Name'
                                            value={recipe.PolicyName}
                                            onChange={(e) => { HandleChange('PolicyName', (e.target.value)) }}
                                            error={errors.PolicyName}
                                            required
                                        />

                                        <div className={`col-md-3 mb-1 cntrl-width`} key="fileDocument">
                                            <label className="form-label">Document<span style={{ color: "red" }}> *</span></label>
                                            <FileUploader
                                                classes='file-upload text-truncate'
                                                types={fileType.split(",")}
                                                handleChange={(file) => handleFileUploader(file, fileType.split(","), setRecipe, recipe, 'DocFileBase64', 'DocFileExt', 'DocFileName')}
                                                children={<FileUploadChild message={recipe.DocFileName + '.' + recipe.DocFileExt} types={fileType.split(",")} />}
                                            />
                                            <div className="error-msg">{errors.DocFileBase64}</div>
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                        </div>

                        <FormButton
                            handleSubmit={handleSubmit}
                            handleClear={handleClear}
                            Export={false }
                        />
                    </div>

                </div>

            </div >

            {/* Table Component start*/}
            <Table
                Token={TokenData}
                PageName='CompanyPolicyMaster'
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                HandleShowDoc={HandleShowDoc}
                handleFilter={() => {
                    getFormData();
                    setFilterData({
                        ...filterData,
                    });
                }}
                tableData={result}
                filterData={filterData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}

export default CompanyPolicyMaster
